import { render, staticRenderFns } from "./UploadBtn.vue?vue&type=template&id=23379c3a&"
import script from "./UploadBtn.vue?vue&type=script&lang=js&"
export * from "./UploadBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports